import styled from 'styled-components';

export const PageBodyWrapper = styled.div`
  height: 100%;
`;
